import { IPassengerInfo } from "@ryde/shared";

export enum RideBottomSiteItemVariant {
  PassengerSite = "passengerSite",
  MatchesRideSite = "matchesRideSite",
  RideSiteMismatch = "rideSiteMismatch",
  NoSite = "noSite",
}

export interface IRideBottomSiteDisplayItem {
  key: string;
  siteId: number;
  label: string;
  passengers: IPassengerInfo[];
  variant: RideBottomSiteItemVariant;
  isClickable: boolean;
  showWarningIcon: boolean;
  /** Shown in tooltip when passenger site differs from ride.siteId. */
  showNotEqualToRideSiteNote: boolean;
}
